<template>
    <div class="simplest-grid">
        <CRow>
            <CCol>
                <ejs-grid ref='grid' :dataSource='stData' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :enablePersistence ="true" :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin="actionBegin" :actionComplete='actionComplete' :actionFailure="actionFailure" :allowExcelExport='true' :excelExportComplete='excelExportComplete'>
                    <e-columns>
                        <e-column field='id' headerText='' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='name' headerText='Strategy Type' :validationRules="nameRules" width=120></e-column>
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions';
    import store from '../../../store';

    import SyncHelper from '../../../common/syncfusion'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        data() {
            return {
                store: store,
                stData: SyncHelper.getDataManager("StrategyType"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.StrategyTypes.Update"],
                    allowAdding: store.state.permissions["Permissions.StrategyTypes.Create"],
                    allowDeleting: store.state.permissions["Permissions.StrategyTypes.Delete"],
                    mode: 'Dialog'
                },
                requiredRules: { required: true },
                nameRules: { required: true, maxLength: 512 },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "StrategyTypes.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
          
                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["name"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            }

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style>
</style>